import styled from 'styled-components/macro';

export const Divider = styled.hr`
    border: 0px;
    border-top: 1px solid #F1F3F8;
    margin: 20px 0;
`;
